import { capworksProgramService } from "@/modules/capworks/store/services/capworks-program-service";

const parseProgramFileEndpoint = capworksProgramService.injectEndpoints({
  endpoints: (builder) => ({
    parseLendingProgramFile: builder.mutation({
      query: ({ file }) => {
        const formData = new FormData();
        formData.append("file", file);

        return {
          url: "lending-programs/parse-file",
          method: "POST",
          body: formData,
        };
      },
      extraOptions: { suppressNotification: true },
    }),
  }),
  overrideExisting: false,
});

export const { useParseLendingProgramFileMutation } = parseProgramFileEndpoint;

